import { parseComprasFriendPrefs, type ComprasFriendPrefs } from "./compras-friends";

/**
 * Which friends "También para" writes to, remembered per viewer in this
 * browser (friendId → on), with the same shape and parsing as Compras'.
 * Missing or unreadable storage reads as nobody: off is the safe default.
 */
export type ComidasSharePrefs = ComprasFriendPrefs;

type StorageLike = Pick<Storage, "getItem" | "setItem">;

export function comidasShareKey(userId: number): string {
  return `nutri:comidas-share:${userId}`;
}

export function loadComidasSharePrefs(userId: number, storage?: StorageLike): ComidasSharePrefs {
  try {
    return parseComprasFriendPrefs((storage ?? globalThis.localStorage).getItem(comidasShareKey(userId)));
  } catch {
    return {};
  }
}

export function saveComidasSharePrefs(userId: number, prefs: ComidasSharePrefs, storage?: StorageLike): void {
  try {
    (storage ?? globalThis.localStorage).setItem(comidasShareKey(userId), JSON.stringify(prefs));
  } catch {}
}
